export default function getCalendarBusinessHours({ users }) {
	if (users?.every((user) => !user.calendarAvailability)) {
		return { daysOfWeek: [0, 1, 2, 3, 4, 5, 6], startTime: "05:00", endTime: "23:00" };
	}

	const userCalendarAvailability = users.reduce(
		(acc, user) => {
			if (!user.calendarAvailability) {
				return acc;
			}

			for (const day of Object.keys(acc)) {
				acc[day].start =
					user.calendarAvailability[day]?.start > acc[day].start
						? user.calendarAvailability[day].start
						: acc[day].start;

				acc[day].end =
					user.calendarAvailability[day]?.end < acc[day].end
						? user.calendarAvailability[day].end
						: acc[day].end;
			}

			return acc;
		},
		{
			1: { start: "05:00", end: "23:00" },
			2: { start: "05:00", end: "23:00" },
			3: { start: "05:00", end: "23:00" },
			4: { start: "05:00", end: "23:00" },
			5: { start: "05:00", end: "23:00" },
			6: { start: "05:00", end: "23:00" },
			7: { start: "05:00", end: "23:00" },
		},
	);

	return Object.entries(userCalendarAvailability).map(([day, { start, end }]) => ({
		daysOfWeek: [Number(day)],
		startTime: start,
		endTime: end,
	}));
}
